import { initAliyunMonitor, initBaiduTracker } from '@lighthouse/shared'

export function initSentry() {
    const { VITE_ENVIRONMENT, VITE_RELEASE_VERSION, VITE_BAIDU_TRACKER_SITE_ID, VITE_ALIYUN_MONITOR_PID, VITE_ALIYUN_MONITOR_ENDPOINT } =
        import.meta.env

    // const sentryEnabled = !!VITE_ENVIRONMENT && VITE_ENVIRONMENT !== 'dev'
    const enabled = VITE_ENVIRONMENT === 'prod'
    // const sentryMaxRate = VITE_ENVIRONMENT === 'prod' ? 0.1 : 0.5

    // 初始化用户行为埋点 // 名杠说不需要了
    // const tracker = new Tracker()
    // tracker.init({ requestUrl: '/lighthouse/api/auth/v1/tracking' })

    // 初始化百度统计
    enabled && initBaiduTracker(VITE_BAIDU_TRACKER_SITE_ID)

    // 初始化阿里云监控
    // enabled && initAliyunMonitor(VITE_ALIYUN_MONITOR_PID, VITE_ALIYUN_MONITOR_ENDPOINT, VITE_RELEASE_VERSION)

    // Sentry.init({
    //     dsn: 'https://97c4b8eab7054e6f911ad6d130c7826f@op.byecode.com/3',
    //     integrations: [
    //         // See docs for support of different versions of variation of react router
    //         // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    //         Sentry.reactRouterV6BrowserTracingIntegration({
    //             useEffect,
    //             useLocation,
    //             useNavigationType,
    //             createRoutesFromChildren,
    //             matchRoutes
    //         }),
    //         Sentry.replayIntegration()
    //     ],
    //     enabled,
    //     environment: VITE_ENVIRONMENT,

    //     // Set tracesSampleRate to 1.0 to capture 100%
    //     // of transactions for performance monitoring.
    //     // We recommend adjusting this value in production
    //     tracesSampleRate: sentryMaxRate
    // })
}
